import { cn } from "@/lib/utils.ts";

/** Isotipo de Alpaca POS: la "A" en un cuadro de la marca. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-600 text-lg font-extrabold text-white",
        className,
      )}
      aria-hidden="true"
    >
      A
    </div>
  );
}

/** Isotipo + nombre, con una línea opcional debajo. */
export function BrandLockup({ caption }: { caption?: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <BrandMark />
      <div className="min-w-0">
        <p className="truncate text-base font-extrabold leading-tight text-slate-900">
          Alpaca <span className="text-brand-600">POS</span>
        </p>
        {caption && <p className="truncate text-xs font-medium text-slate-500">{caption}</p>}
      </div>
    </div>
  );
}
